// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mlOSq {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"b-dot-text": `mlOSq`,
	"bDotText": `mlOSq`
};
export default ___CSS_LOADER_EXPORT___;
